<template>
  <div class="navbar">
    <div class="navbar-left" @click="$router.push({name:'home'})">
      <img :src="logo" alt="Company Logo" />
    </div>
    <div class="navbar-right">
      <div class="navbar-buttons">
        <button v-for="btn in buttons" :key="btn.id" class="navbar-button" @click="goPage(btn.id, btn.route)">{{ btn.label }}</button>
      </div>
      <div v-if="isMobile" class="mobile-menu" @click="toggleMenu">
        <img src="../assets/list.png" alt="Menu Icon" />
      </div>
      <div :class="['menu-overlay', { active: showMenu && isMobile }]">
        <button v-for="btn in buttons" :key="btn.id" class="navbar-button" @click="goPage(btn.id, btn.route)">{{ btn.label }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import {getUser} from "@/axios/token";

export default {
  name:'headerComponent',
  data() {
    // let lang = 'Language';
    return {
      logo:require('@/assets/logo.jpg'),
      buttons: [
        { id: 0, label: '首页',route: 'home' },
        { id: 6, label: '用户手册',route: this.common.docsLink },
        { id: 1, label: '推广免费用',route: 'share' },
        { id: 2, label: '客户端下载',route:'downLoad' },
        {id:3,label: '联系我们',route:'customer'},
        { id: 4, label: '常见问题' ,route: 'answer'},
        { id: 5, label: getUser() ? getUser() : '登录',route:'login'},
        // { id: 5, label: lang }
      ],
      showMenu: false,
    };
  },
  computed: {
    isMobile() {
      return window.innerWidth < 960;
    }
  },
  methods: {
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    goPage(id, name){
      if (id==6) {
        window.location.href = name;
      } else {
        this.$router.push({ name: name, params: { status: name } });
      }
    }
  }
};
</script>

<style scoped>
.navbar {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 10%;
  border-bottom: 1px solid #e9edf5;
}

.navbar-left img {
  height: 40px;
}

.navbar-right {
  display: flex;
  align-items: center;
}

.navbar-right .navbar-buttons {
  display: flex;
}

.navbar-right .navbar-button {
  margin-left: 10px;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  color: #5b617c;
  font: 16px "Roboto Light";
  cursor: pointer;
  background: white;
}

.navbar-right .navbar-button :hover{
  background-color: #ddd;

}

.navbar-right .mobile-menu {
  cursor: pointer;
}

.navbar-right .mobile-menu img {
  height: 30px;
}

.menu-overlay {
  position: absolute;
  top: 60px;
  right: 10px;
  display: none;
  flex-direction: column;
  align-items: flex-end;
  padding: 10px;
  background: white;
  z-index: 1;
}

.menu-overlay.active {
  display: flex;
}

@media (max-width: 960px) {
  .navbar-right .navbar-buttons {
    display: none;
  }
}
@media (max-width: 1080px) {
  .navbar{padding: 10px 5%}
}
</style>
